import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=0040cc10&scoped=true&"
import script from "./HelpPanel.vue?vue&type=script&lang=ts&"
export * from "./HelpPanel.vue?vue&type=script&lang=ts&"
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=0040cc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040cc10",
  null
  
)

export default component.exports